// extracted by mini-css-extract-plugin
module.exports = {"chip":"e_48","stat":"e_58","k":"e_68","v":"e_78","scale":"e_88","text":"e_98","pills":"e_-8"};